import { setToken, removeToken, setOTP, removeOTP } from '@/utils/auth'
import addSeconds from 'date-fns/addSeconds'
import request from '@/plugins/axios'
import { getBaseUrl } from '@/utils/endpoint'
const domain = require('getdomain')
import Cookies from 'js-cookie'

const actions = {
  async fetchToken({ commit, state }, domain_id) {
    // const store_domain_id = domain_id ?? localStorage.getItem('olselforder_url_domain')
    const store_domain_id = domain_id ?? Cookies.get('olselforder_url_domain')
    // const hostname = domain.hostname(window.location.href)
    // let hostname
    // const curr_domain = domain.get(window.location.href)
    // if (!domain_id && domain_id === '' && curr_domain !== 'antarinmakan.com' && curr_domain !== 'indociti.com' && curr_domain !== 'localhost') {
    //   hostname = domain.hostname(window.location.href)
    // } else {
    //   hostname = domain_id
    // }
    // console.log('hostname action', hostname)
    try {
      let selectedlocale = Cookies.getJSON(
        process.env.VUE_APP_COOKIE_LOCALE_KEY + "_Locale"
      );
      if (selectedlocale === undefined || selectedlocale == null) {
        selectedlocale = process.env.VUE_APP_I18N_LOCALE;
      }
      const { data } = await request({
        method: 'get',
        url: `/${selectedlocale}/${store_domain_id}/system/login`,
        baseURL: process.env.VUE_APP_API_URL
      })
      const tokensExpiry = addSeconds(new Date(), data.expires_in)
      data.expires_time = tokensExpiry
      state.loading_axios = false
      commit('SET_TOKEN', data)
      setToken(data.access_token)
      delete data.access_token
      localStorage.setItem('olselforder_auth_data', JSON.stringify(data))
    } catch (e) {
      commit('TOKEN_FAILURE')
    }
  },
  setTokenAnatarinmakan({ commit, state }, data) {
    console.log('set token reservasi', data)
    commit('SET_TOKEN', data)
    localStorage.setItem('olselforder_auth_data', JSON.stringify(data))
  },
  save_token({ commit }, data) {
    if (data !== '') {
      const tokensExpiry = addSeconds(new Date(), data.expires_in)
      data.expires_time = tokensExpiry
      commit('SET_TOKEN', data)
      setToken(data.access_token)
      delete data.access_token
      localStorage.setItem('olselforder_auth_data', JSON.stringify(data))
    } else {
      commit('TOKEN_FAILURE')
    }
  },
  async fetchStore({ commit, state }, { domain_id, outlet_id }) {
    console.log('domain_id action', domain_id)
    try {
      let selectedlocale = Cookies.getJSON(
        process.env.VUE_APP_COOKIE_LOCALE_KEY + "_Locale"
      );
      if (selectedlocale === undefined || selectedlocale == null) {
        selectedlocale = process.env.VUE_APP_I18N_LOCALE;
      }
      const { data } = await request({
        method: 'get',
        // url: `/${domain_id}/outlet/${outlet_id}`,
        url: `/${selectedlocale}/${domain_id}/store`,
        baseURL: process.env.VUE_APP_API_URL
      }).then(res => res.data)
      state.loading_axios = false

      const outlet = await request({
        method: 'get',
        url: `/${selectedlocale}/${domain_id}/outlet/${data.id}`,
        baseURL: process.env.VUE_APP_API_URL
      }).then(res => res.data)
      commit('SET_STORE_DATA', outlet.data)
      localStorage.setItem('olselforder_selected_outlet', JSON.stringify(outlet.data))
    } catch (e) {
      commit('TOKEN_FAILURE')
    }
  },
  async fetchStoreOutlet({ commit, state }, { domain_id, outlet_id }) {
    console.log('domain_id action', domain_id)
    console.log('outlet_id action', outlet_id)
    state.loading_axios = true
    try {
      let selectedlocale = Cookies.getJSON(
        process.env.VUE_APP_COOKIE_LOCALE_KEY + "_Locale"
      );
      if (selectedlocale === undefined || selectedlocale == null) {
        selectedlocale = process.env.VUE_APP_I18N_LOCALE;
      }
      const { data } = await request({
        method: 'get',
        url: `/${selectedlocale}/${domain_id}/outlet/${outlet_id}`,
        baseURL: process.env.VUE_APP_API_URL
      }).then(res => res.data)
      commit('SET_STORE_DATA', data)
      localStorage.setItem('olselforder_selected_outlet', JSON.stringify(data))
    } catch (e) {
      // commit('TOKEN_FAILURE')
      // console.log('error', e)
      // state.show_error = true
      // state.error_message = e.message
      // state.error_type = e.statusCode
    } finally {
      state.loading_axios = false
    }
  },
  checkDomain({ commit, state }, domain_id) {
    // const url_domain = localStorage.getItem('olselforder_url_domain')
    const url_domain = Cookies.get('olselforder_url_domain')
    if (url_domain === undefined || url_domain === '' || !url_domain) {
      commit('SET_URL_DOMAIN', domain_id)
    }
  },
  remove_token({ commit }) {
    commit('SET_TOKEN', null)
    removeToken()
    localStorage.removeItem('olselforder_auth_data')
  },
  removeErrors({ commit }) {
    commit('REMOVE_ERROR')
  },
  saveCustomerData({ commit }, data) {
    commit('SET_CUSTOMER_DATA', data)
    localStorage.setItem(process.env.VUE_APP_COOKIE_KEY + '_data_customer', JSON.stringify(data))
  },
  removeCustomerData({ commit }) {
    commit('SET_CUSTOMER_DATA', {})
    localStorage.removeItem(process.env.VUE_APP_COOKIE_KEY + '_data_customer')
  },
  create_order({ commit }, data) {
    commit('SET_ORDER', data)
    localStorage.setItem(process.env.VUE_APP_COOKIE_KEY + '_order', JSON.stringify(data))
  },
  remove_order({ commit }) {
    commit('SET_ORDER', '')
    localStorage.removeItem(process.env.VUE_APP_COOKIE_KEY + '_order')
  },

  addItemReservation({ commit, state }, reservationData) {
    commit("ADD_ITEM_RESERVATION", reservationData);

    localStorage.setItem(
      process.env.VUE_APP_COOKIE_KEY + '_data_cart_reservation',
      JSON.stringify(state.data_cart_reservation)
    );
  },

  addManyItemReservation({ commit }, reservationData) {
    commit("ADD_MANY_ITEM_RESERVATION", reservationData);

    localStorage.setItem(
      process.env.VUE_APP_COOKIE_KEY + '_data_cart_reservation',
      JSON.stringify(reservationData)
    );
  },

  removeItemReservation({ commit, state }, itemId) {
    commit("REMOVE_ITEM_RESERVATION", itemId);

    localStorage.setItem(
      process.env.VUE_APP_COOKIE_KEY + '_data_cart_reservation',
      JSON.stringify(state.data_cart_reservation)
    );
  },

  removeAllReservation({ commit }) {
    commit("REMOVE_ALL_RESERVATION");

    localStorage.removeItem(process.env.VUE_APP_COOKIE_KEY + '_data_cart_reservation');
  },

  setPyment({ commit }, data) {
    commit('SET_PAYMENT', data)
    localStorage.setItem(process.env.VUE_APP_COOKIE_KEY + '_payment', JSON.stringify(data))
  },
  removePyment({ commit }) {
    commit('SET_PAYMENT', '')
    localStorage.removeItem(process.env.VUE_APP_COOKIE_KEY + '_payment')
  },
  data_verification({ commit }, data) {
    commit('SET_DATA_VERIFICATION', data)
    localStorage.setItem(process.env.VUE_APP_COOKIE_KEY + '_data_verification', JSON.stringify(data))
  },
  data_verification_without_save({ commit }, data) {
    commit('SET_DATA_VERIFICATION', data)
  },
  remove_data_verification({ commit }, data) {
    commit('SET_DATA_VERIFICATION', null)
    localStorage.removeItem(process.env.VUE_APP_COOKIE_KEY + '_data_verification')
  },
  remove_data_verification_without_save({ commit }, data) {
    commit('SET_DATA_VERIFICATION', null)
  },
  save_type_verification({ commit }, data) {
    commit('SET_TYPE_VERIFICATION', data)
    localStorage.setItem(process.env.VUE_APP_COOKIE_KEY + '_type_verification', data)
  },
  remove_type_Verification({ commit }) {
    commit('SET_TYPE_VERIFICATION', null)
    localStorage.removeItem(process.env.VUE_APP_COOKIE_KEY + '_type_verification')
  },
  set_otp_forget_password({ commit }, data) {
    commit('SET_OTP_FORGET_PASSWORD', data)
    setOTP(data)
  },
  remove_otp_forget_password({ commit }) {
    commit('SET_OTP_FORGET_PASSWORD', null)
    removeOTP()
  },
  set_router_data({ commit, state }, data) {
    if (!state.router_data.includes(data)) {
      const data_router = [...state.router_data, data];
      commit('SET_ROUTER_DATA', data_router);
      localStorage.setItem(process.env.VUE_APP_COOKIE_KEY + '_router_data', JSON.stringify(data_router));
    }
  },
  remove_item_router_data({ commit, state }, data) {
    commit('REMOVE_ITEM_ROUTER_DATA', data);
    localStorage.setItem(process.env.VUE_APP_COOKIE_KEY + '_router_data', JSON.stringify(state.router_data));
  },
  remove_all_router_data({ commit }) {
    commit('REMOVE_ALL_ROUTER_DATA');
    localStorage.removeItem(process.env.VUE_APP_COOKIE_KEY + '_router_data');
  },
  set_query_router({ commit, state }, data) {
    commit('SET_QUERY_ROUTER', data);
    localStorage.setItem(process.env.VUE_APP_COOKIE_KEY + '_query_router', JSON.stringify(data));
  }
}

export default actions